import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps';
import { DropdownModule } from 'primeng/dropdown';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { CalendarModule } from 'primeng/calendar';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { DetalhesExtratoComponent } from './detalhes-extrato-bancario/detalhes-extrato-bancario.component';
import { ImportarExtratosBancarios } from './importacao-extrato-bancario/importacao-extrato-bancario.component';
import { ListaExtratoComponent } from './lista-extrato/lista-extrato.component';
import { ToolbarModule } from 'primeng/toolbar';
import { DetalhesListaExtratoComponent } from './detalhes-lista-extrato/detalhes-lista-extrato.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabViewModule } from 'primeng/tabview';
import { CheckboxModule } from 'primeng/checkbox';
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';
import { InfoDialogComponent } from '../../shared/info-dialog/info-dialog.component';
@NgModule({
  declarations: [
    DetalhesExtratoComponent,
    ImportarExtratosBancarios,
    ListaExtratoComponent,
    DetalhesListaExtratoComponent
  ],

  imports: [
    CommonModule,
    FieldsetModule,
    SpinnerServiceComponent,
    ButtonModule,
    FileUploadModule,
    ReactiveFormsModule,
    DropdownModule,
    StepsModule,
    BadgeModule,
    TableModule,
    PanelModule,
    FormsModule,
    CalendarModule,
    FloatLabelModule,
    ToolbarModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    ConfirmDialogModule,
    TabViewModule,
    CheckboxModule,
    ToolbarSearchComponent,
    InfoDialogComponent
  ],
  exports: [
    DetalhesExtratoComponent,
    ImportarExtratosBancarios,
    ListaExtratoComponent,
    DetalhesListaExtratoComponent
  ]
})
export class ExtratoBancarioModule { }
